import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import 'bootstrap/dist/css/bootstrap.min.css';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
// Development helpers: log full objects for unhandled rejections / errors
if (process.env.NODE_ENV === 'development') {
  window.addEventListener('unhandledrejection', (e) => {
    // e.reason can be an Error or any value — log it fully
    // eslint-disable-next-line no-console
    console.error('Unhandled promise rejection:', e.reason);
  });

  window.addEventListener('error', (e) => {
    // eslint-disable-next-line no-console
    console.error('Global error event:', e.error || e.message, e);
  });
}
root.render(
    <div className="main-container">
      <App />
    </div>
);

reportWebVitals();
